import { erpAxios } from '..';

const editProcjenaRizika = async (data) => {
  const res = await erpAxios.post(`/procjenaRizika/edit`, data);
  return res;
};

export default editProcjenaRizika;
